import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useBreadcrumbs } from '@/hooks/useBreadcrumbs';
import { useStanRouter } from '@/hooks/useStanRouter';
import { StanCard } from '@/components';
import { EmailRecipientsTable } from '@/features/email-flows/recipients/components/EmailRecipientsTable';

/**
 * Email Recipients Page
 * Shows the list of recipients who received a specific email in a flow
 * Accessible from EmailActionsMenu and BroadcastActionsMenu
 */
const EmailRecipientsPage = () => {
    const { emailId, page } = useParams();
    const { push } = useStanRouter();
    const parsedEmailId = Number(emailId) || -1;
    const initialPage = Number(page) || 1;

    // Redirect if invalid email ID
    useEffect(() => {
        if (parsedEmailId === -1) {
            push('/flows');
        }
    }, [parsedEmailId, push]);

    useBreadcrumbs([
        { title: 'My Email Flows', to: '/flows', id: 'flows', active: false },
        { title: 'Recipients', to: `/flows/recipients/${emailId}`, id: 'recipients', active: true },
    ]);

    if (parsedEmailId === -1) {
        return null;
    }

    return (
        <div className='mx-auto w-full max-w-screen-lg pb-6'>
            <div className='mb-6'>
                <h1 className='text-heading-h2 mb-1'>Email Recipients</h1>
                <p className='text-secondary text-body-sm'>View all recipients who received this email</p>
            </div>

            <StanCard>
                <EmailRecipientsTable emailId={parsedEmailId} initialPage={initialPage} />
            </StanCard>
        </div>
    );
};

export default EmailRecipientsPage;
